<section class="select-notification">
  <h2 class="title">¿Dónde quieres recibir el código?</h2>
  <h4 class="sub-title">Selecciona otra forma para recibir el código</h4>

  <form #formNotifications="ngForm">
    <div class="smsOption check" *ngIf="sms">
      <input type="radio" name="codeMethod" id="codeMethod" #sms value="sms"  [(ngModel)]="data.bySMS" (ngModelChange)=" chageOption($event) ">
      <div class="info">
        <img src="assets/svg/sms.svg" alt="Icono SMS">
        <div class="txt">
          <h4>Enviar por SMS</h4>
          <p>Al número {{phoneData}}</p>
        </div>
      </div>
    </div>

    <div class="callOption check" *ngIf="call">
      <input type="radio" name="codeMethod" id="call" #call value="call"  [(ngModel)]="data.byCall" (ngModelChange)=" chageOption($event) ">
      <div class="info">
        <img src="assets/svg/call.svg" alt="Icono SMS">
        <div class="txt">
          <h4>Llamada telefónica</h4>
          <p>Al número {{phoneData}}</p>
        </div>
      </div>
    </div>

    <div class="emailOption check" *ngIf="email">
      <input type="radio" name="codeMethod" id="email" #email value="email"  [(ngModel)]="data.byEmail" (ngModelChange)=" chageOption($event) ">
      <div class="info">
        <img src="assets/svg/email.svg" alt="Icono SMS">
        <div class="txt">
          <h4>Enviar por correo electrónico</h4>
          <p>Al correo {{emailData}}</p>
        </div>
      </div>
    </div>

    <div class="callOption check" *ngIf="wapp">
      <input type="radio" name="codeMethod" id="wapp" #wapp value="wapp"  [(ngModel)]="data.byWhatsApp" (ngModelChange)=" chageOption($event) ">
      <div class="info">
        <img src="assets/svg/whatsapp.png" alt="Icono whatsapp">
        <div class="txt">
          <h4>Mensaje por medio de whatsapp</h4>
          <p>Al número {{phoneData}}</p>
        </div>
      </div>
    </div>

    <button type="button" class="button blue-button" [ngClass]="{ 'disabled': isDisabled }" (click)="sendOption()">
      Enviar código
    </button>



  </form>
</section>
